/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAperture = createReactComponent("outline", "aperture", "IconAperture", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3.6 15h10.55", "key": "svg-1" }], ["path", { "d": "M6.551 4.938l3.26 10.034", "key": "svg-2" }], ["path", { "d": "M17.032 4.636l-8.535 6.201", "key": "svg-3" }], ["path", { "d": "M20.559 14.51l-8.535 -6.201", "key": "svg-4" }], ["path", { "d": "M12.257 20.916l3.261 -10.034", "key": "svg-5" }]]);

export { IconAperture as default };
//# sourceMappingURL=IconAperture.mjs.map
